<div class="menu-overlay" [ngClass]="{ 'menu-overlay_opened': isMenuOpened() }" (click)="closeMenu()"></div>
<div class="menu" [ngClass]="{ 'menu_opened': isMenuOpened() }" *transloco="let i18n">
    <div class="menu__logo"></div>
    <div class="menu__list">
        @if ([Permissions.ViewDashboards] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['dashboards']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.FINANCE"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes(activeRoutes.dashboards)"
                ></lib-svg-icon>
                <p>{{ i18n('common.Common.Menu.Label.Dashboard') }}</p>
            </div>
        }
        @if ([Permissions.ViewUsers] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['users', 'list']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.USER"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes('users')"
                ></lib-svg-icon>
                <p>{{ i18n('common.Common.Menu.Label.Users') }}</p>
            </div>
        }
        @if ([Permissions.ManageDisputes] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['disputes']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.MESSAGE"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes('disputes')"
                ></lib-svg-icon>
                <p>{{ i18n('common.Common.Menu.Label.Disputes') }}</p>
            </div>
        }
        @if ([Permissions.ManagePlatformSettings] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['platform-settings']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.SETTINGS"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes('platform-settings')"
                ></lib-svg-icon>
                <p>{{ i18n('common.Common.Menu.Label.PlatformSettings') }}</p>
            </div>
        }
        @if ([Permissions.ManagePaymentProfiles] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['payment']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.WINDOW"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes('payment')"
                ></lib-svg-icon>
                <p>{{ i18n('common.Common.Menu.Label.PaymentProfiles') }}</p>
            </div>
        }
        @if ([Permissions.ManageTeam] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['team']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.USER"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes('team')"
                ></lib-svg-icon>
                <p>{{ i18n('common.Common.Menu.Label.Team') }}</p>
            </div>
        }
        @if ([Permissions.ManageApi] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['api']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.API"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes('api')"
                ></lib-svg-icon>
                <p>{{ i18n('common.Common.Menu.Label.Api') }}</p>
            </div>
        }
        @if ([Permissions.ViewNotifications] | permissions | async) {
            <div class="menu__list-item" [routerLink]="['notifications']" routerLinkActive="menu__list-item_active">
                <lib-svg-icon
                    [icon]="SvgIcons.BELL"
                    color="var(--common-icon-color)"
                    [active]="currentUrl.includes('notifications')"
                ></lib-svg-icon>
                <p
                    [matBadge]="notificationsUnreadCount()"
                    [matBadgeHidden]="!notificationsUnreadCount()"
                    matBadgeOverlap="false"
                >{{ i18n('common.Common.Menu.Label.Notifications') }}</p>
            </div>
        }
    </div>
    <div class="menu__info">
        <app-menu-info (toggleSwitched)="closeMenu()"></app-menu-info>
    </div>
</div>
